'use strict';

DataModelDescriptorService.$inject = ['mx.SolutionBuilderAgent.Http'];
export default function DataModelDescriptorService(http) {
	return {
		getProperties: loadControlDescriptorProperties,
	};

	function isArrayProperty(editor) {
		if (Array.isArray(editor.SupportedTypes)) {
			return editor.SupportedTypes.some(function (type) {
				return type.IsArray;
			});
		}
		return false;
	}

	function getTypeFromEditor(editor) {
		var types = mx.SolutionBuilderAgent.PropertyEditorType;

		switch (editor.Type) {
			case types.Boolean:
				return mx.SolutionBuilderAgent.DataModelTypes.BoolType.name;
			case types.Integer:
				return mx.SolutionBuilderAgent.DataModelTypes.IntType.name;
			case types.Text:
				return mx.SolutionBuilderAgent.DataModelTypes.TextType.name;
			case types.String:
				return mx.SolutionBuilderAgent.DataModelTypes.StringType.name;
			case types.Enumeration:
				return mx.SolutionBuilderAgent.DataModelTypes.StringType.name;
			case types.ObjectPicker:
				return mx.SolutionBuilderAgent.DataModelTypes.ObjectReference.name;
			case types.Schema:
				return mx.SolutionBuilderAgent.DataModelTypes.GuidType.name;
			case types.Bindable:
				var typeName;
				if (Array.isArray(editor.SupportedTypes) && editor.SupportedTypes.length > 0) {
					var type = Number(editor.SupportedTypes[0].Type);

					Object.keys(mx.SolutionBuilderAgent.DataModelTypes).some(function (key) {
						if (mx.SolutionBuilderAgent.DataModelTypes[key].id === type) {
							typeName = mx.SolutionBuilderAgent.DataModelTypes[key].name;
							return true;
						}
					});
				}
				return typeName || mx.SolutionBuilderAgent.DataModelTypes.ObjectType.name;
			default:
				return mx.SolutionBuilderAgent.DataModelTypes.ObjectType.name;
		}
	}

	function loadControlDescriptorProperties(ids) {
		if (!Array.isArray(ids)) {
			ids = [ids];
		}
		return http.post('api/controls/properties', ids).then(function (properties) {
			return (properties || []).map(function (property) {
				var editor = typeof property.Editor === 'string' && property.Editor.length > 0 && property.Editor[0] === '{' ? JSON.parse(property.Editor) || {} : {};
				var direction = editor.BindingType === 1 ? mx.SolutionBuilderAgent.DataModelPropertyDirection.BOTH : mx.SolutionBuilderAgent.DataModelPropertyDirection.IN;
				return {
					name: property.Name,
					camelCasedName: property.Name.toLowerCase().replace(/-([a-z])/g, function (g) {
						return g[1].toUpperCase();
					}),
					title: property.Title,
					direction: direction,
					isArray: isArrayProperty(editor),
					type: getTypeFromEditor(editor),
				};
			});
		});
	}
}
